// 🔧 /util/FullPageSpinner.js
// ✅ Purpose: Reusable full-screen loading spinner with centered text
// ✅ Features:
// - Vertically and horizontally centers spinner using Bootstrap classes
// - Accepts optional `message` prop (default: "Loading...")

import React from "react";

const FullPageSpinner = ({ message = "Loading..." }) => {
  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="text-center">
        <div
          className="spinner-border text-primary"
          role="status"
          style={{ width: "3rem", height: "3rem" }}
        >
          <span className="visually-hidden">{message}</span>
        </div>
        <div className="mt-3 text-muted">{message}</div>
      </div>
    </div>
  );
};

export default FullPageSpinner;
